import * as React from 'react';
import { useState } from 'react'

import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material'

import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../contexts/auth';
import { useCompany } from '../../../contexts/Company';

import { completeActivity } from '../../../hooks/activity';

export default function SendQuiz({ selectedOptions, setOpenQuiz, setQuiz, activity, setCongratulations }) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const history = useHistory();
    const { user } = useAuth();
    const company = useCompany();

    // Handler para abrir la confirmación
    const handleOpenConfirmation = () => {
        setIsDialogOpen(true);
    };

    // Handler para cerrar la confirmación y enviar el quiz
    const handleCloseConfirmation = (confirmed) => {
        setIsDialogOpen(false);
        if (confirmed) {
            setOpenQuiz(false);
            setQuiz(true);
            setCongratulations(true)

            completeActivity(user, activity);

            // Aquí puedes hacer lo que necesites con las opciones seleccionadas
            console.log('Opciones seleccionadas:', selectedOptions);
        }
    };

    // TODO: haz que se marquen las respuestas correctas e incorrectas con verde y rojo, y los puntos ganados

    const confirmationText = company?.id == 45 ? 'Are you sure you want to submit the quiz?' : '¿Estás seguro de que quieres enviar el cuestionario?';
    const noButtonText = company?.id == 45 ? 'No' : 'No';
    const yesButtonText = company?.id == 45 ? 'Yes' : 'Sí';
    const sendButtonText = company?.id == 45 ? 'Send' : 'Enviar';

    return (
        <>
            <Button variant="contained" color="primary" onClick={handleOpenConfirmation} >
                {sendButtonText}
            </Button>
            <Dialog open={isDialogOpen} onClose={() => handleCloseConfirmation(false)}>
                <DialogTitle>{company?.id == 45 ? 'Confirmation' : 'Confirmación'}</DialogTitle>
                <DialogContent>
                    {confirmationText}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleCloseConfirmation(false)} color="primary">
                        {noButtonText}
                    </Button>
                    <Button onClick={() => handleCloseConfirmation(true)} color="primary">
                        {yesButtonText}
                    </Button>
                </DialogActions>
            </Dialog>
        </>)
}